import { Navigate } from "react-router-dom";

export const getScreenNav = (auth, name, name2) => {
    return <Navigate to={"/" + (auth ? name : name2)} replace={true} />;
};

export const getScreen = (auth, screen, name = "login") => {
    return auth ? screen : <Navigate to={"/" + name} replace={true} />;
};
